<body class="ltr main-body leftmenu">
    <form>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5"> {{'header.exam-head.titleList.AllExamHeadRecords' | translate}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">{{'header.exam-head.titleList.ExamHeadData' | translate}}</li>
                                <li class="breadcrumb-item active" aria-current="page">{{'header.exam-head.titleList.AddExamHead' | translate}}</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    {{'header.exam-head.titleList.AddNewRecord' | translate}}
                                </button>
                                <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg" (click)="
                                        download()">
                                    <i class="fe fe-download-cloud me-2"></i> {{'header.exam-head.titleList.DownloadReport' | translate}}
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu> -->
    
                                <!-- <button mat-button [matMenuTriggerFor]="menu">Menu</button>
                                      <mat-menu #menu="matMenu">
                                               <button mat-menu-item>Item 1</button>
                                     <button mat-menu-item>Item 2</button>
                                           </mat-menu> -->
    
                            </div>
                        </div>
                    </div>
                    <!-- End Page Header -->
    
                    <!-- Row -->
                    <!-- list of faculty start  -->
                    <div hidden class="row row-sm" *ngIf="list">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <p class="mb-1">
                                                <span hidden class="main-content-label"><b>{{'header.exam-head.titleList.ExamHead' | translate}}</b></span>
                                                <span>{{'header.exam-head.titleList.List' | translate}}</span>
                                            </p>
                                            <p class="text-muted card-sub-title mb-0">{{'header.exam-head.titleList.ExamHeadDataInformation' | translate}}</p>
                                        </div>
                                        <div class="col-md-5" >
                                            <mat-form-field appearance="outline" class="example-full-width" >
                                                <mat-label>{{'header.exam-head.titleList.Search' | translate}}</mat-label>
                                                <input class="color" matInput placeholder="Search">
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    
                                    <div class="table-responsive">
                                        <table id="datatable"
                                            class="table table-striped table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
    
                                                    <th class="f600">
                                                        {{'header.exam-head.table.MarkList'| translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.Type' | translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.Code' | translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.DefaultName' | translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.Parents' | translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.Print' | translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.Sequence' | translate}}
                                                    </th>
                                                    <th class="f600">
                                                        {{'header.exam-head.table.Order' | translate}}
                                                    </th>
                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data" *ngIf="examHeadList.length > 0">
                                                <tr *ngFor="let examHead of examHeadList;">
    
                                                    <td> {{examHead.EhMarkList}} </td>
                                                    <td>{{examHead.EhType}} </td>
                                                    <td> {{examHead.EhCode}} </td>
                                                    <td>{{examHead.EhDefName}} </td>
                                                    <td> {{examHead.EhParents}} </td>
                                                    <td>{{examHead.EhPrint}} </td>
                                                    <td> {{examHead.EhSeq}} </td>
                                                    <td>{{examHead.EhOrder}} </td>
                                                    <td class="text-center">
    
                                                        <!-- <a class="btn-floating" title="Edit"
                                                            (click)="editdata('true',examHead)">
                                                            <i class="fa fa-edit"></i>
                                                        </a> -->
                                                        <a class="btn-floating" title="Delete" (click)="deletee('true',examHead)">
                                                            <!-- <i class="fas fa-trash"></i> -->
                                                            <i class="fas fa-trash"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
    
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- list of faculty end  -->
                    <!-- add of faculty start  -->
                    <div class="row row-sm" *ngIf="list == false ">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamHeadForm">
                            <div class="col-lg-12 col-md-12">
    
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1"><b>{{'header.exam-head.titleList.AddNewExamHeadRecord' | translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0">{{'header.exam-head.titleList.AddNewExamHeadInformation' | translate}}</p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1"><b>{{'header.exam-head.titleList.UpdateExamHeadRecord' | translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">{{'header.exam-head.titleList.UpdateSelectedExamHeadInformation' | translate}}
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1"><b>{{'header.exam-head.titleList.DeleteExamHeadRecord' | translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">{{'header.exam-head.titleList.DeleteSelectedExamHeadInformation' | translate}}
                                            </p>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.MarkList' | translate}}</mat-label>
                                                            <mat-select onkeydown="return (event.keyCode!=13);" #select55 class="color" formControlName="EhMarkList" required>
                                                                <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                                                    [displayMember]="'CdCode'" [array]="markslist"
                                                                    (filteredReturn)="filteredListMarks =$event"></mat-select-filter>
                                                                    <mat-option  [value]="0">
                                                                        None
                                                                    </mat-option>
                                                                <mat-option *ngFor="let item of filteredListMarks" [value]="item.CdCode" (click)="getList(item.CdCode)">
                                                                    {{item.CdCode}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ExamHeadForm.controls['EhMarkList'].touched && ExamHeadForm.controls['EhMarkList'].errors?.required">
                                                                {{'header.exam-head.titleList.required' | translate}}
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.Type' | translate}}</mat-label>
                                                            <mat-select formControlName="EhType" required>
                                                                    <mat-option value="P" >
                                                                        Part
                                                                    </mat-option>
                                                                <mat-option value="I">
                                                                    Internal Assessments
                                                                </mat-option>
                                                                <mat-option value="H">
                                                                    Head
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="ExamHeadForm.controls['EhType'].touched && ExamHeadForm.controls['EhType'].errors?.required">
                                                                {{'header.exam-head.titleList.required' | translate}}
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.Code' | translate}}</mat-label>
                                                            <input onkeydown="return (event.keyCode!=13);" class="color" matInput formControlName="EhCode"
                                                                placeholder="Short Name" required>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhCode'].touched && ExamHeadForm.controls['EhCode'].errors?.required">
                                                                    {{'header.exam-head.titleList.required' | translate}}
                                                                </mat-error>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhCode'].touched && ExamHeadForm.controls['EhCode'].errors?.pattern">
                                                                    {{'header.exam-head.titleList.pattern' | translate}}
                                                                </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.DefaultName' | translate}}</mat-label>
                                                            <input onkeydown="return (event.keyCode!=13);" class="color" matInput formControlName="EhDefName"
                                                                placeholder="Short Name" required>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhDefName'].touched && ExamHeadForm.controls['EhDefName'].errors?.required">
                                                                    {{'header.exam-head.titleList.required' | translate}}
                                                                </mat-error>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhDefName'].touched && ExamHeadForm.controls['EhDefName'].errors?.pattern">
                                                                    {{'header.exam-head.titleList.pattern' | translate}}
                                                                </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.Parents' | translate}}</mat-label>
                                                            <input onkeydown="return (event.keyCode!=13);" class="color" matInput formControlName="EhParent"
                                                                placeholder="Short Name">
                                                                <!-- <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhParent'].touched && ExamHeadForm.controls['EhParent'].errors?.required">
                                                                    {{'header.exam-head.titleList.required' | translate}}
                                                                </mat-error>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhParent'].touched && ExamHeadForm.controls['EhParent'].errors?.pattern">
                                                                    {{'header.exam-head.titleList.pattern' | translate}}
                                                                </mat-error> -->
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-2 mt-2">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>{{'header.exam-head.titleList.Print' | translate}}</mat-label>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <mat-radio-group [disabled]="isDeleteReadonly"  formControlName="EhPrint"
                                                                class="example-full-width"  required>
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value="Y">Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value="N">No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                            <mat-error class="margin_tp"
                                                            *ngIf="ExamHeadForm.controls['EhPrint'].touched && ExamHeadForm.controls['EhPrint'].errors?.required">
                                                            {{'header.exam-head.titleList.required' | translate}}
                                                        </mat-error>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.Sequence' | translate}}</mat-label>
                                                            <input onkeydown="return (event.keyCode!=13);" class="color" matInput formControlName="EhSeq"
                                                                placeholder="Short Name" required>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhSeq'].touched && ExamHeadForm.controls['EhSeq'].errors?.required">
                                                                    {{'header.exam-head.titleList.required' | translate}}
                                                                </mat-error>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhSeq'].touched && ExamHeadForm.controls['EhSeq'].errors?.pattern">
                                                                    {{'header.exam-head.titleList.pattern' | translate}}
                                                                </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>{{'header.exam-head.titleList.Order' | translate}}</mat-label>
                                                            <input onkeydown="return (event.keyCode!=13);" class="color" matInput formControlName="EhOrder"
                                                                placeholder="Short Name" required>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhOrder'].touched && ExamHeadForm.controls['EhOrder'].errors?.required">
                                                                    {{'header.exam-head.titleList.required' | translate}}
                                                                </mat-error>
                                                                <mat-error class="margin_tp"
                                                                    *ngIf="ExamHeadForm.controls['EhOrder'].touched && ExamHeadForm.controls['EhOrder'].errors?.pattern">
                                                                    {{'header.exam-head.titleList.pattern' | translate}}
                                                                </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-sm-12">
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="submitButton" (click)="submit()">{{'header.exam-head.titleList.Submit' | translate}}</button>
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="editButton" >{{'header.exam-head.titleList.Update' | translate}}</button>
                                                <button type="button"
                                                    class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                    *ngIf="deleteButton" (click)="openConformationModalBox()">{{'header.exam-head.titleList.Delete' | translate}}</button>
                                                <button type="button"
                                                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                    (click)="addnewrecord('false')">{{'header.exam-head.titleList.Back' | translate}}</button>
    
                                            </div>
                                        </div>
                                        <div class="table-responsive">
                                            <table id="datatable"
                                                class="table table-striped table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr>
        
                                                        <th class="f600">
                                                            {{'header.exam-head.table.MarkList'| translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.Type' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.Code' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.DefaultName' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.Parents' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.Print' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.Sequence' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.exam-head.table.Order' | translate}}
                                                        </th>
                                                        <th width="10%" class="f600 text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data" *ngIf="examHeadList">
                                                    <tr *ngFor="let examHead of examHeadList;">
        
                                                        <td> {{examHead.EhMarkList}} </td>
                                                        <td>{{examHead.EhType}} </td>
                                                        <td> {{examHead.EhCode}} </td>
                                                        <td>{{examHead.EhDefName}} </td>
                                                        <td> {{examHead.EhParents}} </td>
                                                        <td>{{examHead.EhPrint}} </td>
                                                        <td> {{examHead.EhSeq}} </td>
                                                        <td>{{examHead.EhOrder}} </td>
                                                        <td class="text-center">
        
                                                            <!-- <a class="btn-floating" title="Edit"
                                                                (click)="editdata('true',examHead)">
                                                                <i class="fa fa-edit"></i>
                                                            </a> -->
                                                            <a class="btn-floating" title="Delete" (click)="deletee('true',examHead)">
                                                                <!-- <i class="fas fa-trash"></i> -->
                                                                <i class="fas fa-trash"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- list of faculty end  -->
                </div>
            </div>
        </div>
    </form>
    </body>





    
    